import { render, staticRenderFns } from "./opg_up_push.vue?vue&type=template&id=467eb3c7&scoped=true"
import script from "./opg_up_push.vue?vue&type=script&lang=js"
export * from "./opg_up_push.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467eb3c7",
  null
  
)

export default component.exports